<template>
    <div class="mt-10" v-if="channels.length > 0">
        <!-- Panel Header -->
        <div class="flex items-center">
            <h3 class="font-medium text-lg text-gray-700 select-none">
                RedRabbit Messenger
            </h3>
        </div>

        <ul class="grid grid-cols-2 gap-4 my-3">
            <li v-for="channel in channels" :key="channel.id" class="col-span-2 md:col-span-1">
                <messenger-channel-list-item :echo="echo" :channel="channel" type="ticket"
                                             @show-channel="showChannel(channel)">
                </messenger-channel-list-item>
            </li>
        </ul>

        <channel-container-modal :show="showChannelModal">
            <div v-if="selectedChannel" class="flex flex-col items-stretch h-full">
                <button @click.prevent="closeChannel"
                        class="cursor-pointer p-2 font-bold bg-gray-700 text-white flex items-center">
                    <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                    </svg>
                    Back
                </button>
                <!-- The selectedChannel && showChannelModal properties are on the SelectChannel mixin-->
                <messenger-channel :channel="selectedChannel" :echo="echo"></messenger-channel>
            </div>
        </channel-container-modal>
    </div>
</template>

<script>
import MessengerListMixin from "../../mixins/messenger-list-mixin";
import ChannelContainerModal from "./ChannelContainerModal";

export default {
    name: "TicketChannelList",

    components: {ChannelContainerModal},

    mixins: [MessengerListMixin],
};
</script>
